import React, { useState } from 'react';
import PropTypes from 'prop-types'
import '../QueuePage.scss'
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const QueueHeaderSortLink = ({ sortValue, updateOrderBy, updateCurrentSort, currentSort, children, order }) => {
    const [orderFlag, setOrderFlag] = useState(order === 'desc');
    const isSortSupported = sortValue != null;

    const handleOnClick = () => {
        setOrderFlag(!orderFlag);
        var order = orderFlag ? 'asc' : 'desc';
        updateOrderBy(sortValue, order);
        updateCurrentSort(sortValue);
    }

    return !(currentSort === sortValue) ? (
        isSortSupported
            ? <a className='queue-header-link' onClick={handleOnClick}>
                {children}
            </a>
            : <div className='queue-header-link-no-sort'>
                {children}
            </div>

    ) : (
        <div className='header-sort-link'>
            {children}
            <div className='header-direction-toggle' onClick={handleOnClick}>
                {!orderFlag &&
                    <ExpandLessIcon />
                }
                {orderFlag &&
                    <ExpandMoreIcon />
                }
            </div>
        </div>
    )
}

QueueHeaderSortLink.propTypes = {
    sortValue: PropTypes.string,
    updateOrderBy: PropTypes.func,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default QueueHeaderSortLink